import React from 'react'
import { Button } from 'reactstrap'
import { useHistory } from 'react-router-dom'
import { message } from 'antd'

function BulkCombineShip(props) {
    const { resetBulkAll, reloadItems, closeMenu, items = [], selectedItems = [] } = { ...props }
    const history = useHistory()

    const onCombineShip = (e) => {
        const listItems = items.filter(item => selectedItems.includes(item._id))
        const listBarcodeNumber = listItems.map(i => i.barcodeNumber)
        const allItemNotHaveLabel = listItems.every(i => {
            const labelDetails = !!i.labelDetails ? i.labelDetails : {}
            return !labelDetails.trackingNumber
        })

        if (!allItemNotHaveLabel) {
            const listBarcodeNumberHasLabel = listItems.filter(i => {
                const labelDetails = !!i.labelDetails ? i.labelDetails : {}
                return !!labelDetails.trackingNumber
            }).map(i => i.barcodeNumber)
            message.error(`Barcode ${listBarcodeNumberHasLabel.join(', ')} đã có label`)
            return
        }
        // Lưu data vào localStorage và mở tab mới 
        localStorage.setItem('combineShipOrders', JSON.stringify(listBarcodeNumber))
        window.open('/combine-ship/create', '_blank', 'noopener,noreferrer')
        resetBulkAll()
        closeMenu()
    }

    return (
        <div className='BulkCombineShip'>
            <Button color="link" onClick={onCombineShip} disabled={false} className="mr-1">Combine ship</Button>
        </div>
    )
}

export default BulkCombineShip